/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, FileData, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../request'
// @ts-ignore
import makeRequestHook from '../makeRequestHook'

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig
}

const mockUrl_0_0_0_0 = 'http://127.0.0.1:50505/mock/0' as any
const devUrl_0_0_0_0 = '' as any
const prodUrl_0_0_0_0 = '' as any
const dataKey_0_0_0_0 = 'data' as any

/**
 * 接口 获取分类信息以及未读数量 的 **请求类型**
 *
 * @分类 消息通知
 * @请求头 `POST /baob/pc.MsgManager/getClassMsg`
 */
export interface PostGetClassMsgRequest {
  supply_id?: string
}

/**
 * 接口 获取分类信息以及未读数量 的 **返回类型**
 *
 * @分类 消息通知
 * @请求头 `POST /baob/pc.MsgManager/getClassMsg`
 */
export type PostGetClassMsgResponse = {
  class_id: string
  class_name: string
  unread_num: string
}[]

/**
 * 接口 获取分类信息以及未读数量 的 **请求配置的类型**
 *
 * @分类 消息通知
 * @请求头 `POST /baob/pc.MsgManager/getClassMsg`
 */
type PostGetClassMsgRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/baob/pc.MsgManager/getClassMsg',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 获取分类信息以及未读数量 的 **请求配置**
 *
 * @分类 消息通知
 * @请求头 `POST /baob/pc.MsgManager/getClassMsg`
 */
const postGetClassMsgRequestConfig: PostGetClassMsgRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/baob/pc.MsgManager/getClassMsg',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'postGetClassMsg',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 获取分类信息以及未读数量 的 **请求函数**
 *
 * @分类 消息通知
 * @请求头 `POST /baob/pc.MsgManager/getClassMsg`
 */
export const postGetClassMsg = /*#__PURE__*/ (requestData: PostGetClassMsgRequest, ...args: UserRequestRestArgs) => {
  return request<PostGetClassMsgResponse>(prepare(postGetClassMsgRequestConfig, requestData), ...args)
}

postGetClassMsg.requestConfig = postGetClassMsgRequestConfig

/**
 * 接口 获取分类信息以及未读数量 的 **React Hook**
 *
 * @分类 消息通知
 * @请求头 `POST /baob/pc.MsgManager/getClassMsg`
 */
export const usePostGetClassMsg = /*#__PURE__*/ makeRequestHook<
  PostGetClassMsgRequest,
  PostGetClassMsgRequestConfig,
  ReturnType<typeof postGetClassMsg>
>(postGetClassMsg)

/**
 * 接口 获取分类对应的消息数据（最多100条，不分页） 的 **请求类型**
 *
 * @分类 消息通知
 * @请求头 `POST /baob/pc.MsgManager/getClassList`
 */
export interface PostGetClassListRequest {
  supply_id?: string
  class_id?: string
}

/**
 * 接口 获取分类对应的消息数据（最多100条，不分页） 的 **返回类型**
 *
 * @分类 消息通知
 * @请求头 `POST /baob/pc.MsgManager/getClassList`
 */
export interface PostGetClassListResponse {
  total: number
  unread_num: number
  list: {
    mps_id: string
    class_id: string
    trigger_type: string
    event_name: string
    push_type: string
    push_start_day: string
    push_end_day: string
    push_time: string
    push_object: string
    appoint_supply_id: string
    access_channel: string
    message_title: string
    message_content: string
    /**
     *  1 是 2 否
     */
    is_jump: string
    jump_link: string
    status: string
    is_revocation: string
    created_id: string
    created_at: string
    updated_at: string
    /**
     *  1 是  2 否
     */
    is_reach: string
    push_datetime: string
  }[]
}

/**
 * 接口 获取分类对应的消息数据（最多100条，不分页） 的 **请求配置的类型**
 *
 * @分类 消息通知
 * @请求头 `POST /baob/pc.MsgManager/getClassList`
 */
type PostGetClassListRequestConfig = Readonly<
  RequestConfig<
    'http://127.0.0.1:50505/mock/0',
    '',
    '',
    '/baob/pc.MsgManager/getClassList',
    'data',
    string,
    string,
    false
  >
>

/**
 * 接口 获取分类对应的消息数据（最多100条，不分页） 的 **请求配置**
 *
 * @分类 消息通知
 * @请求头 `POST /baob/pc.MsgManager/getClassList`
 */
const postGetClassListRequestConfig: PostGetClassListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/baob/pc.MsgManager/getClassList',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'postGetClassList',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 获取分类对应的消息数据（最多100条，不分页） 的 **请求函数**
 *
 * @分类 消息通知
 * @请求头 `POST /baob/pc.MsgManager/getClassList`
 */
export const postGetClassList = /*#__PURE__*/ (requestData: PostGetClassListRequest, ...args: UserRequestRestArgs) => {
  return request<PostGetClassListResponse>(prepare(postGetClassListRequestConfig, requestData), ...args)
}

postGetClassList.requestConfig = postGetClassListRequestConfig

/**
 * 接口 获取分类对应的消息数据（最多100条，不分页） 的 **React Hook**
 *
 * @分类 消息通知
 * @请求头 `POST /baob/pc.MsgManager/getClassList`
 */
export const usePostGetClassList = /*#__PURE__*/ makeRequestHook<
  PostGetClassListRequest,
  PostGetClassListRequestConfig,
  ReturnType<typeof postGetClassList>
>(postGetClassList)

/**
 * 接口 知悉（已读操作） 的 **请求类型**
 *
 * @分类 消息通知
 * @请求头 `POST /baob/pc.MsgManager/reachMsg`
 */
export interface PostReachMsgRequest {
  supply_id?: string
  /**
   * 消息ID
   */
  id?: string
}

/**
 * 接口 知悉（已读操作） 的 **返回类型**
 *
 * @分类 消息通知
 * @请求头 `POST /baob/pc.MsgManager/reachMsg`
 */
export interface PostReachMsgResponse {}

/**
 * 接口 知悉（已读操作） 的 **请求配置的类型**
 *
 * @分类 消息通知
 * @请求头 `POST /baob/pc.MsgManager/reachMsg`
 */
type PostReachMsgRequestConfig = Readonly<
  RequestConfig<'http://127.0.0.1:50505/mock/0', '', '', '/baob/pc.MsgManager/reachMsg', 'data', string, string, false>
>

/**
 * 接口 知悉（已读操作） 的 **请求配置**
 *
 * @分类 消息通知
 * @请求头 `POST /baob/pc.MsgManager/reachMsg`
 */
const postReachMsgRequestConfig: PostReachMsgRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/baob/pc.MsgManager/reachMsg',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'postReachMsg',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
}

/**
 * 接口 知悉（已读操作） 的 **请求函数**
 *
 * @分类 消息通知
 * @请求头 `POST /baob/pc.MsgManager/reachMsg`
 */
export const postReachMsg = /*#__PURE__*/ (requestData: PostReachMsgRequest, ...args: UserRequestRestArgs) => {
  return request<PostReachMsgResponse>(prepare(postReachMsgRequestConfig, requestData), ...args)
}

postReachMsg.requestConfig = postReachMsgRequestConfig

/**
 * 接口 知悉（已读操作） 的 **React Hook**
 *
 * @分类 消息通知
 * @请求头 `POST /baob/pc.MsgManager/reachMsg`
 */
export const usePostReachMsg = /*#__PURE__*/ makeRequestHook<
  PostReachMsgRequest,
  PostReachMsgRequestConfig,
  ReturnType<typeof postReachMsg>
>(postReachMsg)

/* prettier-ignore-end */
